var escape = require("../../../node_modules_linux/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules_linux/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@font-face{font-family:AlibabaPuHuiTi;src:url(" + escape(require("./Alibaba-PuHuiTi-Medium.ttf")) + ") format(\"truetype\");font-weight:400;font-style:normal}", "", {"version":3,"sources":["/data/workspace/web-www.mythware.net/src/assets/fonts/fonts.css"],"names":[],"mappings":"AAAA,WACE,2BAA8B,AAC9B,qDAA4D,AAC5D,gBAAoB,AACpB,iBAAmB,CACpB","file":"fonts.css","sourcesContent":["@font-face {\n  font-family: 'AlibabaPuHuiTi';\n  src: url('./Alibaba-PuHuiTi-Medium.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules_linux/css-loader??ref--6-1!./node_modules_linux/postcss-loader/lib??ref--6-2!./src/assets/fonts/fonts.css
// module id = CT7Z
// module chunks = 40